/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const CreateNotificationPolicyHeaders = zod.object({
  'x-csrf-token': zod.string(),
  'Idempotency-Key': zod.string(),
});

export type CreateNotificationPolicyHeaders = zod.input<typeof CreateNotificationPolicyHeaders>;
export type CreateNotificationPolicyHeadersOutput = zod.output<
  typeof CreateNotificationPolicyHeaders
>;
